<template>
  <div>
    <div class="fw-500 p-3 mx-auto">
      <div
        class="info-card__header bg-light-gray p-2 info-card__header--one-col"
      >
        App Overview and Guide
      </div>

      <!-- std double-column  -->
      <div class="info-card">
        <div class="info-card__icon">
          <div class="image-wrapper image-wrapper--width-30m50">
            <img
              src="https://pixapup.com/wp-content/uploads/2020/12/number-1.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="info-card__body">
          <div class="info-card__header">Upload Your Image</div>
          <div class="info-card__text info-card__text--no-link-dec">
            <p>Look above, near the top of the page.</p>
            <p v-if="uploadSlotsAvailable">
              You'll see an "Upload Image" orange button, like this:
              <router-link to="/upload-image"
                ><button
                  class="layout-section__btn layout-section__btn--action-orange layout-section__btn--block-centered"
                >
                  <i class="fas fa-cloud-upload-alt"></i> Upload Image
                </button>
              </router-link>
            </p>
            <div v-else>
              <p>
                You have maxed out your available
                <span class="italic">Upload Slots</span> so you cannot upload a
                new image right now.
              </p>
              <p>
                But when you <span class="italic">can</span> upload again,
                you'll see an "Upload Image" orange button, like this:
                <router-link to="#"
                  ><button
                    class="layout-section__btn layout-section__btn--action-orange layout-section__btn--block-centered"
                  >
                    <i class="fas fa-cloud-upload-alt"></i> Upload Image
                  </button>
                </router-link>
              </p>
            </div>

            <!-- <div v-if="!uploadSlotsAvailable">
              <div class="image-wrapper image-wrapper--width-150">
                <img
                  src="https://pixapup.com/wp-content/uploads/2020/12/upload-button-in-system-bar-193-24.png"
                  alt=""
                />
              </div>
            </div> -->
            <p class="mt-2">
              Click on that to bring up the
              <span class="italic">New Image Upload</span> form. Fill it in and
              submit it. That's it!
            </p>
            <p class="font-weight-bold mt-4">* Time-Saving Tip *</p>
            <p>
              Sure, the upload form is short, but why type the same info over
              and over every time you upload a new image?
            </p>
            <p>
              <strong
                >Go to your
                <router-link to="/profile">Profile/Preferences</router-link>
                page and fill in the
                <span class="italic">One-Click Fill Form Settings</span>
                section.</strong
              >
              Then, with each new upload you do, you simply click the Form-Fill
              button and the text fields will be filled in for you!
            </p>
            <p>
              Even if future uploads are of different dogs, you just fill in
              your dog's name and breed; the rest of the info - like your name
              and location - is probably the same for each upload.
              <strong>One click and your form is filled in!</strong> Super fast!
            </p>
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="info-card__icon">
          <div class="image-wrapper image-wrapper--width-30m50">
            <img
              src="https://pixapup.com/wp-content/uploads/2020/12/number-2.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="info-card__body">
          <div class="info-card__header">You Are Done! But...</div>
          <div class="info-card__text">
            <p>
              <strong>See and track your images</strong> using the multi-colored
              buttons in your Images Summary panel near the top of the page.
              Click a button to view your images in that particular list.
            </p>
            <p class="italic">
              See the
              <a href="#track-manage-images"
                >Track and Manage Your Images section</a
              >
              below for more info on your Images Summary panel and each of the
              four lists.
            </p>
            <p>
              Also, go ahead and
              <strong>upload another image! And another!</strong>
            </p>
            <p>
              You have a set number of
              <span class="italic">Upload Slots</span> you can fill (your
              maximum number is shown in the panel near the top of the page).
              But when slots become available, you can upload more - there's
              <strong>no limit</strong> to the number of images you may upload.
            </p>
            <p>
              The more images you upload, the more likely your images will be
              selected for a book or calendar, and the more books and calendars
              your images will appear in!
            </p>
            <p>
              <strong>Edit/Delete your images</strong>. These controls are in
              your <span class="italic">Uploads</span> list (the orange button
              above). You can replace the image of an upload, edit its text, or
              delete the upload.
            </p>
            <p>
              Finally, <strong>tell your friends</strong> - please? =) You could
              earn some goodies if you refer enough other dog owners! All the
              details are on the
              <router-link to="/refer">Refer Friends</router-link> page. Thanks!
            </p>
            <p class="font-weight-bold mt-4">
              Any questions at any time?
              <router-link to="/contact">Contact us!</router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="info-card__icon">
          <div class="image-wrapper image-wrapper--width-30m50">
            <img
              src="https://pixapup.com/wp-content/uploads/2020/12/number-3.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="info-card__body">
          <div class="info-card__header">Learn More</div>
          <div class="info-card__text">
            <p>
              <strong>Your Images Lists</strong>. Again, in your Images Summary
              panel near the top of the page, you'll see four (4) buttons:
              Orange, blue, green, and red.
            </p>
            <p>Click a button to view your images in that particular list.</p>
            <p>
              In the <strong>Header</strong> of each list, you will see a
              downward arrow with text:
              <span class="italic">About this list</span>.
            </p>
            <p>It's in the left side of the header panel for that list.</p>
            <p>
              Here's what it looks like for the <strong>Uploads</strong> list:
            </p>
            <div class="image-wrapper image-wrapper--width-300 mb-3">
              <img
                src="https://pixapup.com/wp-content/uploads/2020/12/uploads-list-header-torn-530w.png"
                alt=""
              />
            </div>
            <p>
              Click on <span class="italic">About this list</span> to read more
              about that particular list.
            </p>
            <p>
              Read that <span class="italic">About</span> section in each of the
              four lists and you'll have a really good idea of what Pixapup is
              all about, what <span class="italic">you</span> can do with your
              images, and how <span class="italic">we</span> work with your
              images.
            </p>
            <p>
              <strong>Image Guidelines</strong>. Everything you want and need to
              know about what we're looking for in the images we select for
              publishing is here on the
              <strong
                ><router-link to="/image-guidelines"
                  >Image Guidelines</router-link
                ></strong
              >
              page.
            </p>
            <p>
              For your easy reference, you can also access these image tips and
              guidelines on the <span class="italic">New Image Upload</span> and
              <span class="italic">Replace Image</span> pages.
            </p>

            <p>
              <strong>Frequently Asked Questions</strong>. Want to know even
              more about Pixapup and all that we're doing?
            </p>
            <p class="font-weight-bold">
              Check out the <router-link to="/faq">FAQs</router-link> page.
            </p>

            <p class="mt-4">
              <strong>Main Navigation Menu</strong>. Finally, be sure to explore
              the main menu at the very top of the page.
            </p>
            <p>Everything within Pixapup is accessible there at any time.</p>
            <p>
              And speaking of the main menu, you can
              <strong>choose</strong> whether to have it fixed at the top of the
              page (even if you scroll) or have it scroll
              <span class="italic">with</span> the page.
            </p>
            <p>
              <strong
                >Go to your
                <router-link to="/profile">Profile/Preferences</router-link>
                page</strong
              >. Look in the
              <span class="italic">Layout Settings</span>
              and check/uncheck the checkbox related to the
              <span class="italic">Main Menu Navigation Bar</span> and then
              click the <span class="italic">Save</span> button.
            </p>

            <p id="track-manage-images" class="font-weight-bold mt-4">
              Any questions at any time?
              <router-link to="/contact">Contact us!</router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="info-card info-card--one-col-text-only">
        <div class="info-card__body">
          <div
            class="info-card__header bg-light-gray p-2 info-card__header--one-col"
          >
            Track and Manage Your Images
          </div>
          <div class="info-card__text--one-col">
            <div class="image-wrapper image-wrapper--width-500">
              <img
                src="https://pixapup.com/wp-content/uploads/2020/12/images-summary-panel-labeled.jpg"
                alt=""
              />
            </div>
            <p>
              You'll see this panel near the top of every page. It summarizes
              and gives you access to all your images.
            </p>
            <p class="text-center bg-submit text-white px-3 py-3">
              This allows you to track the status of all your uploaded images at
              <strong>any</strong> time, in <strong>real</strong> time!
            </p>
            <div class="bg-very-light-gray p-2 my-3">
              <p class="font-weight-bold mb-2">
                One Possible Path of Your Uploaded Image:
              </p>
              <p>
                <strong>Uploads -> Selected -> Published</strong>
              </p>
            </div>

            <p>
              When you <strong>upload</strong> a new image, it appears in your
              <strong>Uploads</strong> list (orange button).
            </p>
            <p>
              When we select your image for a book or calendar, the image no
              longer appears in your Uploads list; instead, it's listed in your
              <strong>Selected</strong> list (blue button).
            </p>
            <p>
              When the project is completed and published, the image is no
              longer in your Selected list; instead, you'll see it in your
              <strong>Published</strong> list (green button).
            </p>
            <div class="bg-very-light-gray p-2 mt-4 mb-3">
              <p class="font-weight-bold mb-2">
                The Other Possible Path of Your Uploaded Image:
              </p>
              <p>
                <strong>Uploads -> Unusable</strong>
              </p>
            </div>
            <p>
              To insure quality of the end-products we publish, the images we
              use must meet a few basic guidelines. You can find the guidelines
              on the
              <span class="italic">New Image Upload</span> and
              <span class="italic">Replace Image</span> pages.
            </p>
            <p>
              For any image that does not quite meet the standard, we'll mark it
              <span class="italic">unusable</span>. The image will no longer be
              in your Uploads list; instead, it will be in your
              <strong>Unusable</strong> list.
            </p>
            <p>
              The upshot is that this has freed up an
              <span class="italic">Upload Slot</span> for you!
            </p>
            <p class="font-weight-bold mt-4">
              Any questions at any time?
              <router-link to="/contact">Contact us!</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PageAppOverview',

  computed: {
    ...mapGetters('uploadTracker', ['imageCounts']),

    maxNumUploads: function () {
      return this.imageCounts.maxNumPending || 0;
    },

    numPending: function () {
      return this.imageCounts.numSubmitted + this.imageCounts.numPending || 0;
    },

    uploadSlotsAvailable: function () {
      if (this.numPending < this.maxNumUploads) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
</style>